import { AbstractApi } from '@/api/AbstractApi'
import request from '@/api/request'

class MenuApi extends AbstractApi {
  async updatePosition(slug: string, position: number) {
    const route = this.generateAdminRoute({ slug, suffix: 'update-position' })

    return request.put(route, { position })
  }

  async disable(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'disable' })

    return request.put(route, { enabled: false })
  }

  async enable(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'enable' })

    return request.put(route, { enabled: true })
  }
}

export default new MenuApi('menu')
